import React from "react";
import PageWrapper from '../../containers/app/PageWrapper';
import TreatmentsProvider from '../../store/treatments/treatmentsProvider';
import ClinicsProvider from '../../store/clinics/clinicsProvider';
import Collaborators from "../../containers/treatments/Collaborators";
import PatientDetailsCard from "../../containers/patients/PatientDetails";
import TreatmentAppointment from "../../containers/treatments/TreatmentAppointment";
import CalendlyProvider from "../../store/appointments/appointmentsProvider";
import TreatmentMessages from "../../containers/treatments/TreatmentMessages";
import TreatmentDocuments from "../../containers/treatments/TreatmentDocuments";
import TreatmentTransactions from "../../containers/treatments/TreatmentTransactions";
import useApp from "../../store/app/appContext";
import TreatmentDetailsCard from "../../containers/treatments/TreatmentDetailsCard";
import UsersProvider from "../../store/users/usersProvider";

const STYLES_MAIN = {
  maxWidth: '1800px'
}

function TreatmentDetailsPage(props) {
  const {
    appState: { user, userAccount },
  } = useApp();
  
  const { history: { location } } = props;
  const treatmentInfo = location.state?.treatmentInfo || {};

  return (
    <TreatmentsProvider>
      <ClinicsProvider>
          <CalendlyProvider>
          <PageWrapper navbar title='Treatment details'>
            <div className='mx-auto' style={STYLES_MAIN}>
              <div className="space-y-4">
                <div className="flex flex-col 2xl:flex-row w-full justify-between 2xl:space-x-4">
                  <PatientDetailsCard treatmentInfo={treatmentInfo} />
                  <TreatmentDetailsCard treatmentInfo={treatmentInfo} />
                </div> 
                <UsersProvider>
                  <Collaborators userAccount={userAccount} treatmentInfo={treatmentInfo}/>
                </UsersProvider>
                <TreatmentAppointment user={user} treatmentInfo={treatmentInfo} />
                <TreatmentDocuments treatmentId={treatmentInfo._id}/>
                <TreatmentMessages userAccount={userAccount} treatmentInfo={treatmentInfo} />
                {userAccount.isPatientOrAdmin && <TreatmentTransactions treatmentInfo={treatmentInfo} />}
              </div>

            </div>
        </PageWrapper >
        </CalendlyProvider>
      </ClinicsProvider>
    </TreatmentsProvider>
  );
}
export default TreatmentDetailsPage;